import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import UserManagement from '@/views/user/UserManagement.vue';
import AgentManagement from '@/views/AgentManagement.vue';
import LotteryManagement from '@/views/lottery/LotteryManagement.vue';
import GameManagement from '@/views/lottery/GameManagement.vue';
import OrderManagement from '@/views/OrderManagement.vue';
import AdminManagement from '@/views/AdminManagement.vue';
import LotteryParent from '@/views/lottery/LotteryParent.vue';
import UserList from '@/views/user/UserList.vue';
import ConsumptionRecord from '@/views/user/ConsumptionRecord.vue';
import RealNameRegistration from '@/views/user/RealNameRegistration.vue';
import Recharge from '@/views/user/Recharge.vue';
import Withdraw from '@/views/user/Withdraw.vue';
import Config from '@/views/config/index.vue';
import AccounInfo from '@/views/user/AccounInfo.vue';
import YuebaoRecord from '@/views/user/YuebaoRecord.vue';
import Game from '@/views/game/index.vue';
import GameList from '@/views/game/GameList.vue';
import Result from '@/views/game/Result.vue';
import Image from '@/views/image/index.vue';
import List from '@/views/announcement/List.vue';;
import Announcement from '@/views/announcement/Index.vue';
import PermissionList from '@/views/permission/index.vue';
import Promotion from '@/views/promotion/index.vue';
import PromotionList from '@/views/promotion/list.vue';
import Participate from '@/views/promotion/promotion.vue';
Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        meta: { title: '首页', icon: 'el-icon-menu' }
      },
      {
        path: 'user-management',
        component: UserManagement,
        meta: { title: '用户管理', icon: 'el-icon-user' },
        children: [
          {
            path: 'list',
            component: UserList,
            meta: { title: '用户列表', icon: 'el-icon-user' }
          },
          {
            path: 'recharge',
            component: Recharge,
            meta: { title: '充值' }
          },
          {
            path: 'withdraw',
            component: Withdraw,
            meta: { title: '提现' }
          },
          {
            path: 'consumption-record',
            component: ConsumptionRecord,
            meta: { title: '消费记录', icon: 'el-icon-money' }
          },
          {
            path: 'account-info',
            component: AccounInfo,
            meta: { title: '提现方式' }
          },
          {
            path: 'yuebaorecord',
            component: YuebaoRecord,
            meta: { title: '余额宝' }
          },
          {
            path: 'real-name-registration',
            component: RealNameRegistration,
            meta: { title: '实名登记', icon: 'el-icon-document' }
          }
        ]
      },
      {
        path: 'permission',
        component: PermissionList,
        meta: { title: '权限管理', icon: 'el-icon-lock' },
      },


      {
        path: 'game',
        component: Game,
        meta: { title: '开奖/赔率', icon: 'el-icon-s-operation' },
        children: [
          {
            path: 'list',
            component: GameList,
            meta: { title: '赔率列表', icon: 'el-icon-game' }
          },
          {
            path: 'result',
            component: Result,
            meta: { title: '开奖结果', icon: 'el-icon-game' }
          }
        ]
      },
      {
        path: 'order-management',
        component: OrderManagement,
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'announcement',
        component: Announcement,
        meta: { title: '公告/弹窗', icon: 'el-icon-s-comment' },
        children: [
          {
            path: 'list',
            component: List,
            meta: { title: '公告列表', icon: 'el-icon-s-comment' }
          }
        ]
      },
      {
        path: 'promotion',
        component: Promotion,
        meta: { title: '促销', icon: 'el-icon-s-promotion' },
        children: [
          {
            path: 'list',
            component: PromotionList,
            meta: { title: '促销列表', icon: 'el-icon-s-comment' }
          },
          {
            path: 'participate',
            component: Participate,
            meta: { title: '参加列表', icon: 'el-icon-s-comment' }
          }
        ]

      },
      {
        path: 'agent-management',
        component: AgentManagement,
        meta: { title: '代理管理', icon: 'el-icon-s-cooperation' }
      },
      {
        path: 'admin-management',
        component: AdminManagement,
        meta: { title: '管理员管理', icon: 'el-icon-s-management' }
      },
      {
        path: 'lottery-management',
        component: LotteryParent,
        meta: { title: '彩种管理', icon: 'el-icon-tickets' },
        children: [
          {
            path: 'category', // 修改为不同的路径
            component: LotteryManagement,
            meta: { title: '种类管理', icon: 'el-icon-game' }
          },
          {
            path: 'game-management',
            component: GameManagement,
            meta: { title: '游戏管理', icon: 'el-icon-game' }
          }
        ]
      },

      {
        path: 'config',
        component: Config,
        meta: { title: '配置管理', icon: 'el-icon-s-management' },
        children: [
      ]
      },
      {
        path: 'image',
        component: Image,
        meta: { title: '图片管理', icon: 'el-icon-picture' }
      }
    ]
  }
];

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token'); // 检查是否存在 token
  if (to.path !== '/login' && !isAuthenticated) {
    next('/login'); // 未登录则重定向到登录页面
  } else {
    next(); // 已登录则继续导航
  }
});

export default router;